import React, { useState, useEffect, useContext, createContext } from "react";
import { fetchBranding } from "../services/branding.service";

const brandingContext = createContext();

export function ProvideBranding({ children }) {
  const brandingData = useProvideBranding();
  return <brandingContext.Provider value={brandingData}>{children}</brandingContext.Provider>;
}

export function useBranding() {
  return useContext(brandingContext);
}

export function useProvideBranding() {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const brandingData = await fetchBranding();
      setBranding(brandingData);
      setLoading(false);
    };
    fetchData();
  }, []);

  return {
    branding,
    loading,
  };
}
